import React from 'react'
import ReactDOM from 'react-dom'
import { Helmet } from 'react-helmet'
import { NotificationManagerProvider, OIOProvider } from 'oio-react'
import { BrowserRouter, Link } from 'react-router-dom'
import { init as initSentry } from '@sentry/browser'
import { sentryDsn } from 'config/constants'
import uiConstants from 'config/constants/ui'
import GlobalApp from 'src/sites/kits/Global'
import ApolloProvider from 'src/sites/kits/Utils/ApolloProvider'
import ErrorBoundary from 'src/sites/kits/Utils/ErrorBoundary'
import MaintenanceContainer from 'src/sites/kits/Utils/MaintenanceContainer'
import MyNotificationCountProvider from 'src/sites/kits/Utils/MyNotificationCountProvider'
import OrganizationProvider from 'src/sites/kits/Utils/OrganizationProvider'

import 'react-dates/initialize'
import './style.less'

initSentry({
   dsn: sentryDsn,
   environment: process.env.NODE_ENV,
   release: process.env.CV5_RELEASE_ID,
   sampleRate: process.env.NODE_ENV === 'production' ? 1 : 0
})

const oioButtonLinkAdapter = {
   render: ({ linkTo, linkReplace, linkExact, ...props }) => (
      <Link to={linkTo} replace={linkReplace} {...props} />
   )
}

ReactDOM.render((
   <MaintenanceContainer>
      <OIOProvider
         id="oio-container"
         buttonLinkAdapter={oioButtonLinkAdapter}
         fontFamily="neue-haas-unica, Helvetica Neue, Helvetica, sans-serif">
         <ErrorBoundary height="100vh">
            <Helmet defaultTitle="Communities" />
            <ApolloProvider>
               <BrowserRouter>
                  <NotificationManagerProvider zIndex={uiConstants.zIndexes.notificationManager}>
                     <OrganizationProvider>
                        <MyNotificationCountProvider>
                           <GlobalApp />
                        </MyNotificationCountProvider>
                     </OrganizationProvider>
                  </NotificationManagerProvider>
               </BrowserRouter>
            </ApolloProvider>
         </ErrorBoundary>
      </OIOProvider>
   </MaintenanceContainer>
), document.getElementById('container'))

if (module.hot) {
   module.hot.accept()
}
